export enum TileShape {
  square = "square",
  rectangle = "rectangle",
}

export interface Tile {
  chart: string | null;
  tileShape: TileShape;
}

export class Row {
  tiles: Tile[];

  isEmpty(): boolean {
    return this.tiles.every((tile) => tile.chart === null);
  }
}

export class DashboardData {
  rows: Row[];
  private activeCharts: string[];

  constructor(info?: Partial<DashboardData>) {
    this.rows = [];
    this.activeCharts = [];
    Object.assign(this, info);
  }

  public addRow() {
    const newRow: Row = new Row();
    newRow.tiles = [
      { chart: null, tileShape: TileShape.square },
      { chart: null, tileShape: TileShape.square },
    ];
    this.rows = [...this.rows, newRow];
  }

  public setTileChart(row: number, tile: number, chart: string) {
    this.rows[row].tiles[tile].chart = chart;
    this.UpdateActiveCharts();
  }

  public removeRow(row: number) {
    this.rows.splice(row, 1);
    this.UpdateActiveCharts();
  }

  public removeTile(row: number, tile: number) {
    this.rows[row].tiles[tile].chart = null;
    this.UpdateActiveCharts();
  }

  private UpdateActiveCharts() {
    this.activeCharts = [];
    for (let row of this.rows) {
      for (let tile of row.tiles) {
        if (tile.chart !== null) {
          this.activeCharts.push(tile.chart);
        }
      }
    }
  }

  public getActiveCharts() {
    this.UpdateActiveCharts();
    return this.activeCharts;
  }

  static fromJSON(json: any): DashboardData {
    return Object.assign(new DashboardData(), json, {
      rows: json.rows.map((row: any) => {
        const newRow = new Row();
        newRow.tiles = row.tiles.map((tile: any) => {
          return {
            chart: tile.chart ? tile.chart : null,
            tileShape: tile.tileShape ? tile.tileShape : TileShape.square,
          };
        });
        return newRow;
      }),
    });
  }
}
